import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { useSelector, useDispatch } from 'react-redux'

import ProductCta from './ProductCta'

import { selectProductCtas } from '../../../../flux/selectors/product'
import { selectUserNearestStoreId } from '../../../../flux/selectors/user'
import { uxEvent } from '../../../../flux/actions/ux'
import { ORIGIN_LANDING } from '../../../../helpers/const'

const StyledCTAsWrapper = styled.div(({ theme: { spaces } }) => ({
  paddingTop: spaces.default / 2,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  margin: '0 auto',
  paddingBottom: 0,
}))

const ProductCategoryGridCtas = ({
  productId, position,
}) => {
  const dispatch = useDispatch()
  const nearestStoreId = useSelector(selectUserNearestStoreId)
  const productCtas = useSelector(
    selectProductCtas(productId, nearestStoreId, { gridCardMode: true }),
  )
  const onCtaClick = ctaType => {
    dispatch(uxEvent({
      name: 'click',
      target: `ProductDetail/${ctaType}`,
      params: {
        productId,
        context: ORIGIN_LANDING,
        position,
      },
    }))
  }

  return (
    productCtas && productCtas.length ? (
      <StyledCTAsWrapper data-test="ProductCategoryGridCtas">
        {productCtas.map(cta => (
          <ProductCta
            key={cta.type}
            ctaType={cta.type}
            href={cta.href}
            target={cta.target}
            text={cta.text}
            toggleText={cta.toggleText}
            color={cta.color}
            backgroundColor={cta.backgroundColor}
            borderColor={cta.borderColor}
            hasIcon={cta.hasIcon}
            hasToggleIcon={cta.hasToggleIcon}
            gridCardMode
            onClick={onCtaClick}
          />
        ))}
      </StyledCTAsWrapper>
    ) : null
  )
}

ProductCategoryGridCtas.propTypes = {
  productId: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
}

ProductCategoryGridCtas.displayName = 'ProductCategoryGridCtas'
ProductCategoryGridCtas.whyDidYouRender = true

export default React.memo(ProductCategoryGridCtas)
